import { ApiError } from "@vana/core";

export class GetTeamError extends ApiError {}

export class ListDeliveriesError extends ApiError {}
